import { Alert, AlertTitle } from '@mui/material'
import { form } from '../formState'
import { useTexts } from '../../hooks/useTexts'
import { useLanguageOptions } from '../hooks/useLanguageOptions'

interface Props {
  supportedLanguages: Record<string, string>
}

export function NotificationLanguage(props: Props) {
  const texts = useTexts()
  const { field } = form.useFormField('notificationLanguage')
  const fieldValueChanged = field.resetValue !== field.value
  const options = useLanguageOptions(props.supportedLanguages)

  return (
    <>
      <form.Autocomplete
        label={texts.notificationLanguage}
        validateOn="change"
        name="notificationLanguage"
        testId="notificationLanguage"
        options={options}
      />
      {fieldValueChanged && (
        <Alert severity="warning" sx={{ '&.MuiAlert-root': { mt: 2 } }}>
          <AlertTitle>{texts.cardTitle}</AlertTitle>
          {texts.cardDescription}
        </Alert>
      )}
    </>
  )
}
